import { createContext, RefObject, useContext, useMemo, useRef, useState } from 'react'
import { useDebounceCallback, useResizeObserver } from 'usehooks-ts'

interface ISize {
  width?: number
  height?: number
  ref?: RefObject<HTMLDivElement | null>
}

export const SizeContext = createContext<ISize>({
  width: undefined,
  height: undefined,
  ref: undefined
})

interface IProps {
  className?: string
  debounce?: number
  children: React.ReactNode
}

export const SizeProvider = ({ className, debounce = 100, children }: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [size, setSize] = useState<ISize>({
    width: undefined,
    height: undefined
  })

  const onResize = useDebounceCallback(setSize, debounce)

  useResizeObserver({
    ref: ref as RefObject<HTMLDivElement>,
    onResize
  })

  const state = useMemo(() => ({ ...size, ref }), [size, ref])

  return (
    <SizeContext.Provider value={state}>
      <div ref={ref} className={className}>
        {children}
      </div>
    </SizeContext.Provider>
  )
}

export const useSizeContext = () => useContext(SizeContext)
